import React from 'react';
import { useTranslation } from 'react-i18next';
import StoryTitle from '../components/StoryTitle';
import PostUser from '../components/PostUser';
import UserReactionScope from '../components/UserReactionScope';
import Voting from '../components/WiwFooter/Voting';
import ButtonShare from '../components/Buttons/ButtonShare';
import { HeartIcon, TranslateIcon, CommentEditIcon, RepostIcon } from '../components/Brand/Icon';
import lessons from './lessons.json';
import { translateLesson } from './translations';
import '../pages/reaction/ReactionContent/ReactionContent.css';
import './onboarding.scss';

const author = { first_name: 'WIW', user_name: 'wiw', picture: null };
export const lessonCards = lessons.map((lesson, index) => ({ id: -1 - index, lesson,
  story: { title: lesson.title }, scope: 4 }));
export const mutedProps = (muted, className = '') => ({
  className: `${className}${muted ? ' onboarding-muted' : ''}`.trim(),
  inert: muted ? '' : undefined,
  'aria-hidden': muted || undefined,
});

// Static lessons deliberately do not mount ReactionContent's vote/like/view
// hooks. Only real public cards can become API, editor or statistics targets.
export default function OnboardingCard({ lesson, signedIn = false, score, onScore, onOpen, targetReady }) {
  const { t, i18n } = useTranslation();
  const content = translateLesson(lesson, i18n.resolvedLanguage || i18n.language, signedIn);
  const muted = lesson.step < 4;
  return <div className="reaction-wrapper reaction-card onboarding-card" data-onboarding-step={lesson.step}>
    <div className="reaction-card-header">
      <StoryTitle title={content.title} onSection={onOpen} sectionsDisabled={!targetReady} />
      <div {...mutedProps(muted)}>
        <PostUser author={author} scope={4} profileInteractive={false} scopeInteractive={false}
          action={<UserReactionScope scope={4} interactive={false} />} />
      </div>
    </div>
    <div className="reaction_content">
      <div className="reaction_content_text">
        {content.paragraphs.map((text, index) => <p key={index}>{text || <br />}</p>)}
      </div>
    </div>
    <div className="control-panel-reaction">
      <div className="reaction-actions__read" />
      <div className="reaction-actions">
        <div {...mutedProps(muted, 'reaction-actions__like')}>
          <button type="button" className="wiw-icon-button control-panel-reaction-like" onClick={() => onOpen('login')}
            aria-label={t('reaction.like', { defaultValue: 'Like' })}>
            <HeartIcon className="nav-icon" /><span>0</span>
          </button>
        </div>
        <button {...mutedProps(muted, 'wiw-icon-button control-panel-reaction-translate')} type="button" disabled
          aria-label={t('reaction.translate', { defaultValue: 'Translate reaction' })}><TranslateIcon className="nav-icon" /></button>
        <span {...mutedProps(lesson.step < 3)}>
          <button type="button" className="wiw-icon-button reaction-comment-link" disabled={!targetReady}
            aria-label={t('post.your_opinion')} onClick={() => onOpen('comment')}><CommentEditIcon className="nav-icon" /></button>
        </span>
        <button {...mutedProps(lesson.step < 3, 'wiw-icon-button reaction-actions__repost')} type="button"
          disabled={!targetReady} aria-label={t('brand:repostAction')} onClick={() => onOpen('repost')}><RepostIcon className="nav-icon" /></button>
        <div {...mutedProps(muted, 'onboarding-share')}>
          <ButtonShare shareUrl="/?entry=share" shareTitle="WIW" shareText="Let’s break some echo chambers and find out who is who." />
        </div>
      </div>
      <div {...mutedProps(lesson.step < 2)}><Voting scope={score} onChange={onScore} /></div>
    </div>
  </div>;
}
